import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import styles from './SheetPreview.module.scss'

type SheetPreviewProps = {
  className?: string
  data?: Record<string, unknown>[]
}

export const SheetPreview = ({ className, data = [] }: SheetPreviewProps) => {
  const keys = Object.keys(data[0] ?? {})

  return (
    <Box
      className={cx(styles.sheet, { [className ?? '']: Boolean(className) })}
    >
      <table className={styles.table}>
        <thead>
          <tr>
            {keys.map((header, index) => (
              <th className={styles.cell} key={index}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {Object.values(row).map((value, idx) => (
                <td className={styles.cell} key={idx}>
                  {value as React.ReactNode}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  )
}
